import { useQuery } from 'react-query';

import { getNotificationPreferencesUseCases } from '@personnel/composition';
import type { NotificationPreferencesConfigDto } from '@personnel/application/dtos';

/**
 * The notification matrix the screen has to paint.
 *
 * It belongs to the organization and not to any user, so the same answer serves a creation and an
 * edition and it is worth keeping cached for the session.
 */
export const useNotificationPreferencesConfig = () => {
  const { getConfig } = getNotificationPreferencesUseCases();

  return useQuery<NotificationPreferencesConfigDto>({
    queryKey: ['notification-preferences-config'],
    queryFn: () => getConfig.execute(),
    staleTime: Infinity,
  });
};
